'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getFirstItinerary = getFirstItinerary;
exports.getAvailableHours = getAvailableHours;
exports.checkFieldError = checkFieldError;
exports.validateListingHelpers = validateListingHelpers;
exports.prepPhotographDates = prepPhotographDates;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _helpers = require('utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getFirstItinerary(meetingPoints) {
  if (meetingPoints.length > 0) {
    var points = meetingPoints.reduce(function (prev, curr) {
      var found = _lodash2.default.find(prev, { type: curr.type });
      if (found) {
        found.names.push(curr.name);
        return prev;
      }
      return [].concat((0, _toConsumableArray3.default)(prev), [{ city: curr.city, type: curr.type, names: [curr.name] }]);
    }, []);
    if (points.length > 1) {
      var names = points.map(function (type) {
        if (type.type === 'Hotel Pickup') {
          return '\n- Hotel lobby (in ' + type.city + ' area)';
        }
        return '\n- ' + type.type + ' (' + type.names.join(', ') + ')';
      }).join('');
      return 'Meet up at your preferred meeting point' + names;
    }
    if (points[0].type === 'Hotel Pickup') {
      return 'Meet up at hotel lobby (in ' + points[0].city + ' area)';
    }
    return 'Meet up at ' + points[0].type + ' (' + points[0].names.join(', ') + ')';
  }
  return 'Meet up at your preferred meeting point';
}

function getAvailableHours(itinerary, index) {
  if (index === 0) {
    return _helpers.hours;
  }
  var prev = '08';
  itinerary.map(function (it, i) {
    var hour = it.time ? it.time.split(':')[0] : '';
    if (hour && i < index) {
      prev = hour;
    }
  });
  return [].concat((0, _toConsumableArray3.default)(_helpers.hours.slice(_helpers.hours.indexOf(prev))), (0, _toConsumableArray3.default)(_helpers.hours.slice(0, _helpers.hours.indexOf(prev)))).slice(0, 8).map(function (hr) {
    return hr;
  });
}

function checkFieldError(name, value) {
  if (name === 'destination_location' || name === 'name' || name === 'introduction') {
    if (value) {
      return false;
    }
    return true;
  }
  if (name === 'activities' || name === 'meeting_points') {
    if (value && value.length > 0) {
      return false;
    }
    return true;
  }
  if (name === 'images') {
    if (value && value.length >= 3) {
      return false;
    }
    return true;
  }
  if (name === 'cover_image') {
    if (value && value.length > 0) {
      return false;
    }
    return true;
  }
  if (name === 'itinerary') {
    var itineraryCount = 0;
    value.map(function (it, index) {
      if (index === 0) {
        if (it.time) {
          itineraryCount += 1;
        }
      } else {
        if (it.text && it.time) {
          itineraryCount += 1;
        }
      }
    });
    if (itineraryCount < 3) {
      return true;
    }
    return false;
  }
  if (name === 'faqs') {
    var faqs = [];
    value.map(function (f) {
      if (f.answer) {
        faqs.push(false);
      } else {
        faqs.push(true);
      }
    });
    return faqs.indexOf(true) >= 0;
  }
  if (name === 'available_days') {
    if (value.indexOf(true) < 0) {
      return true;
    }
    return false;
  }
}

function validateListingHelpers(listing, index) {
  var warning = {};
  var fieldError = {};
  if (index >= 0) {
    var basic = false;
    ['destination_location', 'activities'].map(function (field) {
      if (checkFieldError(field, listing.get(field))) {
        basic = true;
        fieldError[field] = true;
      } else {
        fieldError[field] = false;
      }
    });
    warning.basic = basic;
  }
  if (index >= 1) {
    var overview = false;
    ['name', 'introduction', 'images', 'cover_image'].map(function (field) {
      if (checkFieldError(field, listing.get(field))) {
        overview = true;
        fieldError[field] = true;
      } else {
        fieldError[field] = false;
      }
    });
    warning.overview = overview;
  }
  if (index >= 2) {
    var detail = false;
    ['meeting_points', 'itinerary', 'faqs'].map(function (field) {
      if (checkFieldError(field, listing.get(field))) {
        detail = true;
        fieldError[field] = true;
      } else {
        fieldError[field] = false;
      }
    });
    warning.detail = detail;
  }
  if (index >= 4) {
    var conditions = false;
    if (checkFieldError('available_days', listing.get('available_days'))) {
      conditions = true;
      fieldError.available_days = true;
    } else {
      fieldError.available_days = false;
    }
    warning.conditions = conditions;
  }
  return { warning: warning, fieldError: fieldError };
}

// export function isRequestPhotographer(photographDates) {
//   let count = 0;
//   if (photographDates) {
//     photographDates.map(()=> {
//       count += 1;
//     });
//     if (count) {
//       return true;
//     }
//   }
//   return false;
// }

function prepPhotographDates(photographDates) {
  var data = [];
  if (photographDates) {
    photographDates.map(function (date) {
      if (date) {
        data.push(date);
      }
    });
  }
  return data;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/listing.js
// module id = 481
// module chunks = 47